export default function (relativePath: string) {
  const config = useRuntimeConfig()
  return `${config.public.clientUrl.replace(/\/$/, '')}/${relativePath.replace(/^\//, '')}`
}
